import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";

const BASE_PATH = "/api/wh-allocation";

const api = pythonVmInstance;

export const uploadFile = (formData, onUploadProgress) =>
	api.post(`${BASE_PATH}/upload`, formData, {
		headers: { "Content-Type": "multipart/form-data" },
		onUploadProgress,
	});

export const getDefaultZoneMapping = () =>
	api.get(`${BASE_PATH}/default-zone-mapping`);

export const getFacilityMapping = () => api.get(`${BASE_PATH}/facility-mapping`);

export const runAllocation = (body) =>
	api.post(`${BASE_PATH}/run-allocation`, body);

export const downloadFile = (filename) =>
	api.get(`${BASE_PATH}/download/${filename}`, { responseType: "blob" });

export const getJobs = (params = {}) =>
	api.get(`${BASE_PATH}/jobs`, { params });

export const getJob = (jobId) => api.get(`${BASE_PATH}/jobs/${jobId}`);

export const updateJob = (jobId, data) => api.patch(`${BASE_PATH}/jobs/${jobId}`, data);

export const cancelJob = (jobId) => api.put(`${BASE_PATH}/jobs/${jobId}/cancel`);

export const deleteJob = (jobId) => api.delete(`${BASE_PATH}/jobs/${jobId}`);
